/**
 * Availability domain English translations
 */

import type { AvailabilityTranslation } from './types'

export const availabilityTranslationEn: AvailabilityTranslation = {
  admin: {
    availability: {
      title: 'Factory Availability',
      subtitle: 'Configure which product variants are available at each factory',
      totalFactories: 'Factories',
      totalVariants: 'Variants',
      available: 'Available',
      unavailable: 'Unavailable',
      coverage: 'Coverage',
      coverageDesc: 'of total combinations',
      matrix: 'Availability Matrix',
      factory: 'Factory',
      variant: 'Variant',
      noData: 'No factories or variants available',
    },
  },
}
